export default __webpack_public_path__ + "static/media/icon_romanFeet_right.09fa5559.png";